module.exports = __webpack_public_path__ + "fonts/huxiaobo.1c6242d6.otf";